import React from 'react';
import ReactDOM from 'react-dom'
import { Quill } from 'react-quill';
import moment from 'moment';
import { Tooltip } from 'antd';

const DEFAULT_DATE_FORMAT = `${process.env.REACT_APP_VARIABLE_DATE_FORMAT}`.toUpperCase();


const Embed = Quill.import('blots/embed');
class MentionEmbed extends Embed {

  static create(data) {
    const tooltipTitle = data.placeHolderText === "custom_logic" ? data?.tooltipTitle : data.placeHolderText; 
    const node = super.create();
    if(data.isEmail !== undefined && JSON.parse(data.isEmail) && (data.variableType === "Date" || data.variableType === "ListDate")){
     node.innerHTML += `\${${data.value +'?string("' + data.dateFormat + '")'}}`;
    } else if (typeof data.isPreview === 'string' ? data.isPreview === 'true' : data.isPreview) {
        node.innerHTML = `${data.value}`;
    }
    else{
      if(data['variableType'] === 'Date') {
        node.innerHTML += `\${${data.value}}`;
      } else {
        const wrapper = document.createElement('span');
        wrapper.className = data.isLogicMention ? 'logic' : 'variable';
        ReactDOM.render(
          <Tooltip title={tooltipTitle}>
            {data.isLogicMention ? (
              <span>@func({data.placeHolderText})</span>
            ) : (
              `\${${data.value}}`
            )}
          </Tooltip>,
          wrapper,
        );
        node.appendChild(wrapper); 
      }
    }
    return MentionEmbed.setDataValues(node, data);
  }

  static setDataValues(element, data) {
    const domNode = element;
    let listString = {};
    Object.keys(data).forEach(key => {
      const isShortMessage = (typeof data.shortmessage === 'string' ? data.shortmessage !== "undefined" : data.shortmessage !== undefined) && JSON.parse(data.shortmessage);
      const isPreview = typeof data.isPreview === 'string' ? data.isPreview === 'true' : data.isPreview;
      domNode.dataset[key] = key === 'extraInfo' ? typeof data[key] === 'string' ? data[key] : JSON.stringify(data[key]) : data[key];
      if (data['variableType'] === 'ListString') {
        if (isPreview) { // TODO : Make this view possible to overflow
        listString = `${data.value
          .map((a, i) => {
            return ` \u2022&nbsp;&nbsp;&nbsp; ${a}`;
          })
          .join(`\n`)}`;
        domNode.innerHTML = listString;
        } else {
        listString = `${Array(data.isComplexDesign ? 5 : parseInt(data['count']))
          .fill(0)
          .map((a, i) => {
            return ` \u2022 ${data['vname'] + (i + 1)}`;
          })
          .join(`\n`)}`;
          
          if(isShortMessage) {
            domNode.innerHTML = '';
          } else {
            domNode.innerHTML = '';
            domNode.dataset['list'] = listString;
          }
        }
      }
      else if (data['variableType'] === 'ListDate') {
        listString = `${Array(parseInt(data['count']))
          .fill(0)
          .map((a) => {
            return ` \u2022 ${data['vname']}`;
          })
          .join(`\n`)}`;
        domNode.dataset['list'] = listString;
      }
      else if(data['variableType'] === 'Date'){
        domNode.dataset['date'] =  isPreview ? moment(data.value, DEFAULT_DATE_FORMAT).format(data.dateFormat.toUpperCase()) : data.value;
      }
    });
    if (data['variableType'] === 'ListString') {
      const wrapper = document.createElement('span');
      ReactDOM.render(
        <Tooltip title={data.placeHolderText}>
          {listString}
        </Tooltip>,
        wrapper
      );
      domNode.appendChild(wrapper); 
    }
    return domNode;
  }

  static value(domNode) {
    return domNode.dataset;
  }
}

MentionEmbed.blotName = 'mention';
MentionEmbed.tagName = 'span';
MentionEmbed.className = 'mention';

export default MentionEmbed;
